export const textTranslations = (section, language, props) => {
    if(language === "english") {
        if(section === "main") {
            return <><span>&copy; 2026 The Boggler Inc.<br className="break-on-mobile" />  </span><span> <i>🪷</i> crafted with wisdom and care <i>🪷</i>  </span></>
        }
        if(section === "privacy-policy") {
            return "Privacy Policy"
        }
        if(section === "terms-of-use") {
            return "Terms of Service"
        }
    } else if(language === "sinhala") {
        if(section === "main") {
            return <><span>&copy; 2025 boglar (pudgalika) samāgama <br className="break-on-mobile" />  </span><span> <i>🪷</i> pragnāva saha sælakillen nirmāṇaya karana ladī <i>🪷</i>  </span></>
        }
        if(section === "privacy-policy") {
            return <span>rahasyatā prathipattiya</span>
        }
        if(section === "terms-of-use") {
            return <span>bhāvithā kondēsi</span>
        }
    }
}